// extracted by css-extract-rspack-plugin
export default {"root":"ZqAAOe","expanded":"cQpUsH"};